<div class="dropdown-container">

  <div class="input-group">
    <input 
      type="text" 
      class="search-input"
      [(ngModel)]="searchTerm" 
      (input)="filterList()" 
      (focus)="isOpen = true"
      [placeholder]="placeholder"
    />
    <span class="arrow-icon" [class.rotated]="isOpen"></span>
  </div>

  <ul *ngIf="isOpen" class="dropdown-list">
    
    <li *ngIf="filteredItems.length === 0" class="no-results">
      No results
    </li>

    <li 
      *ngFor="let item of filteredItems" 
      (click)="selectItem(item[displayKey])"
      class="dropdown-item"
      [class.active]="selectedItem && selectedItem[displayKey] === item[displayKey]"
    >
      <span class="main-text">{{ item[displayKey] }}</span>

    </li>
  </ul>

</div>